import React, { useCallback, useEffect, useState } from 'react';
import Slider from 'rc-slider';import { SketchPicker } from 'react-color';
import {fabric} from 'fabric';

import 'rc-slider/assets/index.css';

const DrawingTool = ( {canvas, className=""})=>{
    const [picker, setPicker] = useState(false);
    const [mode, setMode] = useState('select');
    const [color, setColor] = useState('#000');
    const [width, setWidth] = useState(1);

    useEffect(() => {
        setPicker(false);
        setMode('select');
        setColor('#000');
        setWidth(1);
        return () => {
            
        }
    }, []);
    

    function onChangeDrawingMode(mode){
        // let mode = !drawingMode;
        if(mode==='brush'){
            var brush = new fabric.PencilBrush();
            brush.width = width
            brush.color = color;
            brush.canvas = canvas;
            
            canvas.freeDrawingBrush = brush;
            canvas.isDrawingMode = true;
        }else{
            canvas.isDrawingMode = false;
        }
        // canvas.isDrawingMode = (mode!=='select');
        canvas.renderAll();
        setMode(mode);
    }

    const onChangeLineWidth = useCallback(
        (value)=>{
            setWidth(value);
            canvas.freeDrawingBrush.width = Number(value) || 10;
        }, [canvas]);

    const onChangeColor = useCallback(
        (color)=>{
            canvas.freeDrawingBrush.color = color.hex;
            setColor(color.hex);
        }, [canvas]);

    if(canvas===null)return null;
    return (
        <div className="drawingToolContainer">
            <div className="controls text-center">
                <button className={`btn ${ (mode==='select')?'active':''}`} onClick={()=>onChangeDrawingMode('select')}>
                    &nbsp;<i className="fas fa-mouse-pointer"></i>&nbsp;
                </button>
                <button className={`btn ${ (mode==='brush')?'active':''}`} onClick={()=>onChangeDrawingMode('brush')}>
                    <i className="fas fa-pen"></i>
                </button>
            </div>
            { mode==='brush' &&
                <div className="options">
                    <div className="option lineWidth">
                        <div className="label">선 굵기 <span className="value">{width}</span></div>
                        <Slider min={1} max={150} value={width} onChange={onChangeLineWidth}  tipFormatter={value=>`${value}$`} />
                    </div>
                    
                    <div className="option colorPicker">
                        <div className="label">선 색</div>
                        <div className="swatch" onClick={()=>{setPicker(!picker)}}>
                            <div className="color" style={ {background:`${color}`}} />
                        </div>
                        { picker &&
                            <div className="popover">
                                <div className="cover" onClick={ ()=>{setPicker(false)} }/>
                                <SketchPicker color={ color } onChange={ onChangeColor } />
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    );

}//end

DrawingTool.defaultProps = {
    canvas:null,
    className:'left'
};
export default DrawingTool;